<template>
  <div class="app-right-main">
    <div class="app-right-top-header">

      <div class="vertical-center header-content">

        <el-button type="primary" @click="addApp" class="add-button">
          添加App
        </el-button>

        <el-button type="primary" @click="addVersion" class="add-button">
          添加版本
        </el-button>

        <el-button type="primary" @click="addPackage" class="add-button">
          上传安装包
        </el-button>
      </div>

    </div>

    <div class="app-right-table-content">
      <el-table
        :data="appList"
        stripe
        style="width: 100%">


        <el-table-column  align="center" label="App名" prop="name">

        </el-table-column>

        <el-table-column  align="center" label="平台" :formatter="formatPlatform">

        </el-table-column>

        <el-table-column  align="center" label="更新时间" prop="updateTime">

        </el-table-column>


        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="addVersionForApp(scope.$index, appList)">添加版本
            </el-button>

            <el-button type="text" size="small" @click.native.prevent="showVersionsForApp(scope.$index, appList)">
              查看版本
            </el-button>

            <el-button type="text" size="small" @click.native.prevent="editApp(scope.$index, appList)">编辑
            </el-button>
            <el-button type="text" size="small" @click.native.prevent="deleteApp(scope.$index, appList)">删除
            </el-button>

            <el-button type="text" size="small" @click.native.prevent="deleteApp(scope.$index, appList)">上传安装包
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>


    <el-dialog title="添加App" :visible.sync="appDialogVisible" @close="closeAppDialog">

      <add-app :edit-app-form="editAppForm" @clickCancel="closeAppDialog"
               @clickConfirm="submitApp"></add-app>
    </el-dialog>

    <el-dialog title="添加App版本" :visible.sync="appVersionDialogVisible" @close="closeAppDialog">

      <add-app-version :visible="appVersionDialogVisible" :editVersionForm="appVersionForm"
                       @clickCancel="closeAppDialog"
                       @clickConfirm="submitAppVersion"></add-app-version>

    </el-dialog>

    <el-dialog title="版本查看" :visible.sync="appVersionListDialogVisible" @close="closeAppDialog">
      <app-version-list :app-id="operationAppId">

      </app-version-list>

    </el-dialog>
  </div>
</template>

<script>
  import AddApp from './addApp'
  import { createApp, createAppVersion, deleteApp, getAppList } from '../../api/appManageApi'
  import { handleResponse } from '../../utils/response'
  import AddAppVersion from './addAppVersion'
  import AppVersionList from './singleAppVersionList'

  export default {
    name: 'AppManage',
    components: {
      AddAppVersion,
      AddApp,
      AppVersionList
    },
    mounted () {
      this.getAppList()
    },
    data () {
      return {
        operationAppId: -1,
        appDialogVisible: false,
        appVersionDialogVisible: false,
        appVersionListDialogVisible: false,
        editAppForm: {},
        appVersionForm: {},
        appList: []
      }
    },
    methods: {
      formatPlatform (row, column) {
        let n = parseInt(row.platform)
        if (n === 1) {
          return 'iOS'
        } else if (n === 2) {
          return 'Android'
        }
        return '-'
      },
      closeAppDialog () {
        this.appVersionListDialogVisible = false,
          this.appVersionDialogVisible = false
        this.appDialogVisible = false
      },
      addApp () {
        this.editAppForm = {}
        this.appDialogVisible = true
      },
      getAppList () {
        getAppList().then(response => {
          handleResponse(response, data => {
            this.appList = data.list
          }, error => {
          })
        })
      },
      submitAppVersion (e) {
        createAppVersion(e).then(response => {
          handleResponse(response, data => {
          }, error => {
          })
        })
      },
      submitApp (e) {
        createApp(e).then(response => {
          handleResponse(response, data => {
              this.getAppList()
            },
            error => {

            }
          )
        })
      },
      addPackage(){

      },
      addVersion () {
        this.appVersionForm = {}
        this.appVersionDialogVisible = true
      },
      addVersionForApp (index, rows) {
        let id = this.appList[index].id
        this.appVersionForm = { 'appId': id }
        this.appVersionDialogVisible = true
      },
      showVersionsForApp (index, rows) {
        this.operationAppId = this.appList[index].id
        console.log('operationAppId---------' + this.operationAppId)
        this.appVersionListDialogVisible = true
      },
      editApp (index, rows) {
        this.editAppForm = this.appList[index]
        this.appDialogVisible = true
      },
      deleteApp (index, rows) {
        let id = this.appList[index]['id']
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteApp(id).then(response => {
              handleResponse(response, data => {
                  this.getAppList()
                },
                error => {

                }
              )
            }
          )
        }).catch(() => {
        })
      }
    }
  }
</script>

<style scoped>

</style>
